import { ButtonMain } from '@/modules/common/components/button';
import { MidFiltersBar } from './components/mid-filters-bar';
import { TopFiltersBar } from '@@/search/components/top-filters-bar';
import styles from './index.module.sass';
import { useCallback, useEffect, useState } from 'react';
import { IStore } from '@/modules/mixing/components/mixing-by-params-modal/hooks';
import {
  $mixingParamsData,
  $myWarehouses,
  fetchMixingParamsData,
  fetchMyWarehouses,
} from '@/widgets/recipe/model';
import { useStore } from 'effector-react';
import { useNavigate } from 'react-router-dom';
import { validateModal } from '@/modules/mixing/components/mixing-by-params-modal/utils';
import { notification } from 'antd';
import {
  indicateWheatType,
  multiWheatType,
} from '@/modules/common/helpers/wheat-type.helper';
import { submitFx } from '../../functions/submit-search.function';
import { IMockStore, ISearchState, IWheatData } from '../../ts/index.types';
import { useIndicateClass } from '../../hooks/indicate-class.hook';
import { getWheatClass } from '../../functions/get-wheat-class.function';
import { debounce } from 'lodash-es';
import { AGRICULTURES, SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY } from '../../constants';
import {
  $searchByParams,
  setValuesToSearchByParams,
  setWarehousesToSearchByParams,
} from '../../store/search-by-params.store';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';

export const ByParamsSearch = () => {
  const warehouses = useStore($myWarehouses);

  const { reIndicateClassAction, reIndicateClassState } = useIndicateClass();
  const searchState = useStore($searchByParams);

  const agricultures = useStore($agriculture);
  const wheat = agricultures.find((item) => item.name === AGRICULTURES[0].name);
  const wheatRanges = {
    gluten: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[0].name,
    ),
    humidity: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[1].name,
    ),
    idk: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[2].name,
    ),
    cp: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[3].name,
    ),
    protein: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[4].name,
    ),
    nature: wheat?.parameters.find(
      (item) => item.name === AGRICULTURES[0].parameters[5].name,
    ),
  };

  const getClassByParams = useCallback(
    debounce(async () => {
      const result_class = await getWheatClass(searchState);
      const cachedSearchState = localStorage.getItem(
        SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY,
      );
      const parsed = cachedSearchState ? JSON.parse(cachedSearchState) : null;
      setWarehousesToSearchByParams({
        ...searchState,
        stores: parsed?.stores,
        wheatData: { ...searchState.wheatData, class: +result_class },
      });
    }, 100),
    [searchState],
  );

  useEffect(() => {
    getClassByParams();
  }, [reIndicateClassState]);

  // useEffect(() => {
  //   if (searchState === searchInitialState) return;
  //   localStorage.setItem(SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY, JSON.stringify(searchState));
  // }, [searchState]);

  // useEffect(() => {
  //   const cachedSearchState = localStorage.getItem(SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY);
  //   if (cachedSearchState) {
  //     const parsed = JSON.parse(cachedSearchState);
  //     setSearchState(parsed);
  //   };
  // }, [])

  const selectStoreHandler = (option: IMockStore) => {
    const updatedValue = searchState?.stores?.map((item) => {
      if (item.id === option.id)
        return {
          ...item,
          checked: !item.checked,
        };
      return item;
    });
    setWarehousesToSearchByParams({ ...searchState, stores: updatedValue });
  };

  const selectAllStoresHandler = () => {
    const updatedValue = searchState?.stores?.map((item) => {
      return {
        ...item,
        checked: true,
      };
    });
    setWarehousesToSearchByParams({ ...searchState, stores: updatedValue });
  };

  const deselectAllStoresHandler = () => {
    const updatedValue = searchState?.stores?.map((item) => {
      return {
        ...item,
        checked: false,
      };
    });
    setWarehousesToSearchByParams({ ...searchState, stores: updatedValue });
  };

  useEffect(() => {
    // тут загрузка списка хранилищ от API
    fetchMyWarehouses();

    // отлов ошибки при отправке формы
    fetchMixingParamsData.failData.watch((error) =>
      notification.error({ message: 'Ошибка', description: error.message }),
    );
  }, []);

  useEffect(() => {
    if (warehouses) {
      const newSearchState = {
        ...searchState,
        stores: warehouses.map((item) => {
          const existingWarehouse = searchState.stores.find(
            (whs) => whs.id === item.id,
          );
          if (existingWarehouse) {
            return { ...existingWarehouse, label: item.name };
          }
          return {
            id: item.id,
            label: item.name,
            checked: false,
          };
        }),
      };
      setWarehousesToSearchByParams(newSearchState);
      localStorage.setItem(
        SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY,
        JSON.stringify(newSearchState),
      );
    }
  }, [warehouses]);

  // useEffect(() => {
  //   if (searchState) {
  //     const res = indicateWheatType(searchState.wheatData.sort, searchState.wheatData.type)
  //     console.log('res- ', res)
  //   }
  // }, [searchState])

  const navigate = useNavigate();

  const resultData: any = useStore($mixingParamsData);

  return (
    <div className={styles.root}>
      <TopFiltersBar
        stores={searchState.stores}
        onSelectStore={(option: IMockStore) => {
          selectStoreHandler(option);
        }}
        deselectAll={() => {
          deselectAllStoresHandler();
        }}
        onSelectAll={() => {
          selectAllStoresHandler();
        }}
      />
      <MidFiltersBar
        state={searchState.wheatData}
        reIndicateClassAction={reIndicateClassAction}
        setState={(val: IWheatData) =>
          setValuesToSearchByParams({ ...searchState, wheatData: val })
        }
      />
      <ButtonMain
        className={styles.action}
        label="получить варианты"
        onClick={() =>
          submitFx({
            searchState,
            navigate,
            resultData,
            wheatForValidation: wheatRanges as any,
          })
        }
      />
    </div>
  );
};
